import { render, staticRenderFns } from "./ideaSpecsPreview.vue?vue&type=template&id=78760f12&scoped=true"
import script from "./ideaSpecsPreview.vue?vue&type=script&lang=js"
export * from "./ideaSpecsPreview.vue?vue&type=script&lang=js"
import style0 from "./ideaSpecsPreview.vue?vue&type=style&index=0&id=78760f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78760f12",
  null
  
)

export default component.exports